import logBeforeReloadAction from './log-before-reload-action';
import logAfterReloadAction from './log-after-reload-action';

export default {
  logBeforeReloadAction,
  logAfterReloadAction,
};
